import React, { useEffect, useState } from 'react';
import './Projects.css';
import { FaReact, FaNodeJs, FaAws, FaDatabase, FaDocker, FaAngular, FaGithub, FaGitlab, FaGoogle, FaJava, FaJenkins, FaMicrosoft, FaPython, FaVuejs } from 'react-icons/fa';
import { SiRubyonrails, SiPostgresql, SiMongodb, SiMaterialdesign, SiHtml5, SiCss3, SiJquery, SiAwsamplify, SiFirebase, SiTerraform, SiArgo, SiTypescript,  SiExpress, SiRedis, } from 'react-icons/si';
import { Project } from '../types';
import { GrDeploy, GrKubernetes } from "react-icons/gr";

const techIcons: { [key: string]: JSX.Element } = {
  "ReactJS": <FaReact />,
  "NodeJS": <FaNodeJs />,
  "AWS": <FaAws />,
  "PostgreSQL": <SiPostgresql />,
  "MongoDB": <SiMongodb />,
  "Ruby On Rails": <SiRubyonrails />,
  "Material UI": <SiMaterialdesign />,
  "HTML5": <SiHtml5 />,
  "CSS3": <SiCss3 />,
  "jQuery": <SiJquery />,
  "AWS-ECS": <SiAwsamplify />,
  'Cognito': <FaAws />,
  'Lambda': <FaAws />,
  'ECS': <FaAws />,
  'Jenkins': <FaJenkins />,
  'Docker': <FaDocker />,
  'GraphQL': <FaDatabase />,
  'CI/CD': <FaGitlab />,
  'GitLab': <FaGitlab />,
  'GitHub': <FaGithub />,
  'Heroku': <GrDeploy />,
  'Netlify': <GrDeploy />,
  'Firebase': <SiFirebase />,
  'GCP': <FaGoogle />,
  'Azure': <FaMicrosoft />,
  'Kubernetes': <GrKubernetes />,
  'Terraform': <SiTerraform />,
  'ArgoCD': <SiArgo />,
  'Java': <FaJava />,
  'Spring Boot': <FaJava />,
  'Python': <FaPython />,
  'Node.js': <FaNodeJs />,
  'Express.js': <FaNodeJs />,
  'Hibernate': <FaJava />,
  'Maven': <FaJava />,
  'Gradle': <FaJava />,
  'JUnit': <FaJava />,
  'Mockito': <FaJava />,
  'Jest': <FaReact />,
  'React': <FaReact />,
  'Angular': <FaAngular />,
  'Vue.js': <FaVuejs />,
  'Next.js': <FaReact />,
  'Gatsby': <FaReact />,
  'Nuxt.js': <FaVuejs />,
  'Redux': <FaReact />,
  'Vuex': <FaVuejs />,
  'Tailwind CSS': <SiCss3 />,
  'Bootstrap': <SiCss3 />,
  'JQuery': <SiJquery />,
  'TypeScript': <SiTypescript />,
  'Express': <SiExpress />,
  'Redis': <SiRedis />,
};

// Mock projects data - replace with actual API call
const mockProjectsData: Project[] = [
 
 {
    title: "Gemstone Price Prediction System",
    description: "A Gemstone Price Prediction System using Machine Learning analyzes various gemstone characteristics such as carat, cut, color, clarity, and dimensions to accurately estimate market prices. The system preprocesses gemstone datasets using Pandas and NumPy for data cleaning and feature engineering, while Scikit-learn models are trained to identify pricing patterns and generate reliable predictions through an interactive web interface.",
    image: { url: "https://i.pinimg.com/1200x/e6/ad/9f/e6ad9fcae68e8c0d8f08ef476b5115e2.jpg" },
    techUsed: "Machine Learning,MLOPS, CI/CD, Apache Airflow, Python, Scikit-learn, Pandas, NumPy, Flask, HTML, CSS, JS"
}, 
{
    title: "Brain-Cancer Detection System",
    description: "A Brain-Cancer Detection System using a CNN image classification model leverages deep learning techniques to automatically identify and categorize brain tumor types from MRI images. The system preprocesses MRI scans using OpenCV for image enhancement, NumPy for numerical operations, and employs a TensorFlow/Keras-based Convolutional Neural Network to learn distinctive features of cancerous versus non-cancerous tissues.",
    image: { url: "https://i.pinimg.com/736x/82/7a/28/827a285c96dd7a13f3f0257a427773af.jpg" },
    techUsed: "Deep Learning, Mobile.net, VGG16, ResNet50, Flask,  HTML, CSS, JS "
  },
  {
    title: "Audio-Text-Translation",
    description: "An Audio-Text-Translation application that converts spoken language into written text and translates it into multiple target languages. The system utilizes advanced speech recognition models (such as Whisper) to transcribe audio input into text accurately. It then employs powerful language translation models (like GPT or other transformer-based models) to translate the transcribed text into the desired languages, providing users with seamless multilingual communication capabilities.",
    image: { url: "https://i.pinimg.com/1200x/18/27/00/182700728623b7776b9d4e8aa0af0ef7.jpg" },
    techUsed: "Deep Learning, GenAI, Hugging Face, Flask,  HTML, CSS, JS "
  },
 
  {
    title: "Diet-Meal Recommendation System",
    description: "A Diet Meal Recommendation System powered by AI utilizes advanced language models (such as GPT and LLaMA) to generate personalized meal plans based on user preferences, health goals, and dietary restrictions. The system features a user-friendly web interface built with React.js, a backend API powered by Node.js, and MongoDB for storing user profiles and meal data.",
    image: { url: "https://i.pinimg.com/736x/08/cb/cf/08cbcf7193b9ed644d58dc57cf4149e6.jpg" },
    techUsed: "LLMs, LangChain, Flask, HuggingFace, HTML, CSS, JS"
  },
  {
    title: "PrepAi- Your personal AI Assistant",
    description: "PrepAi – Your Personal AI Assistant is an intelligent digital companion powered by advanced language models (such as GPT and LLaMA) designed to help users with various everyday tasks. It features a sleek web interface built with React.js, a robust backend using Node.js, and leverages MongoDB to securely manage user data and assistant interactions.",
    image: { url: "https://i.pinimg.com/736x/b0/34/51/b034516bdde2ae3d39c87010ea1d157c.jpg" },
    techUsed: "React, FireBase, TypeScript, Vapi AI, Vercel, Next.Js"
  },
  {
    title: "NLP Text Translation System",
    description: "An NLP Text Translation System using Natural Language Processing and Deep Learning techniques enables automatic translation of text between multiple languages with improved contextual understanding. The system preprocesses textual data using tokenization and sequence padding, while TensorFlow/Keras-based sequence models learn language patterns to generate accurate translations through an interactive and user-friendly interface.",
    image: { url: "https://i.pinimg.com/1200x/47/11/66/4711667c8fc8e74137e7584b521ff7c8.jpg" },
    techUsed: "NLP, Deep Learning, TensorFlow, Keras, Python, Flask, HTML, CSS, JS"
},
  {
    title: "Bizz-Your Movie Search Platform",
    description: "Bizz – Your Movie Search Platform is a dynamic application designed to help users effortlessly discover and explore movies tailored to their interests. The platform features a modern web interface built with React.js, a backend powered by Node.js, and MongoDB for efficiently managing user profiles and movie metadata",
    image: { url: "https://i.pinimg.com/736x/80/d2/c0/80d2c00f78a37a0c999652f483f618ce.jpg" },
    techUsed: "AppWrite, Tmdb API, Next Js, React"
  },

  {
    title: "Sign Language Recognition System",
    description: "A Sign Language Recognition System using Computer Vision and Convolutional Neural Networks (CNN) enables real-time recognition of hand gestures and finger spelling from camera-captured images. The system preprocesses hand gesture images using image filtering and feature extraction techniques, while a TensorFlow/Keras-based CNN model learns gesture patterns to accurately classify and translate American Sign Language gestures into understandable text output.",
    image: { url: "https://i.pinimg.com/1200x/53/e9/b4/53e9b45f5cfa39b2bf2cfe397273a055.jpg" },
    techUsed: "Computer Vision, CNN, Deep Learning, TensorFlow, Keras, OpenCV, Python, Flask, HTML, CSS, JS"
},
 
  
];

const getProjects = async (): Promise<Project[]> => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  return mockProjectsData;
};

const Projects: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const data = await getProjects();
        setProjects(data);
      } catch (err) {
        setError('Failed to load projects. Please try again later.');
        console.error('Error fetching projects:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjects();
  }, []);

  if (isLoading) {
    return (
      <div className="projects-container">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading projects...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="projects-container">
        <div className="error-state">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <div className="projects-container">
        <div className="empty-state">
          <p>No projects available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="projects-container">
      <div className="projects-header">
        <h2>My Projects</h2>
        <p>A showcase of applications and systems I've built using various technologies</p>
      </div>
      
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div
            key={`${project.title}-${index}`}
            className="project-card"
            style={{ '--delay': `${index * 0.1}s` } as React.CSSProperties}
          >
            <img src={project.image.url} alt={project.title} className="project-image" />
            <div className="project-details">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="tech-used">
                {project.techUsed.split(', ').map((tech, i) => (
                  <span key={i} className="tech-badge">
                    {techIcons[tech] || "🔧"} {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;